import api from '@/api';
import { API_BASE_URL } from '..';

const GENERATE_URL = `${API_BASE_URL}/generate/kits`;

export async function generateKitsReport(format: string) {
  const result = (await api.getReport(GENERATE_URL, { format })) as unknown;
  return result as BlobPart;
}
